export default __webpack_public_path__ + "static/media/WordWork_12.054bf96c.png";